import gsap from 'gsap'
import { shuffle, moveOneLetter, marquee } from '../utils/string'
import { shuffleContainerTexts, shuffleElementTexts } from '../utils/html'

const DURATION = 0.25;
let timeline;

export default {
    name: 'default',
    leave(data) {

        const timeoutPromise = new Promise(resolve => {
            setTimeout(resolve, 250)
        })

        const shufflePromise = new Promise(resolve => {
            let inviewItems = []

            let observer = new IntersectionObserver((entries, observer) => {
                // Add each intersecting entry to inviewItems array
                entries.forEach((entry) => {
                    if(entry.isIntersecting) {
                        const target = entry.target;
                        if((!target.children.length || target.dataset.allowShuffle != undefined) && target.innerText) {
                            inviewItems.push(target)
                        }
                    }
                })

                // console.log(inviewItems);

                // Destroy intersection observer
                observer.disconnect()
                observer = null;

                // Do the shuffle
                timeline && timeline.kill && timeline.kill()
                timeline = gsap.timeline({
                    onComplete: resolve
                })
                // tl.to(data.current.container, { opacity: 0, duration: DURATION/2 }, DURATION/2);

                const shufflePerSecond = 16;
                // const shuffleDelay = 10/shufflePerSecond

                for(let i = 0; i < shufflePerSecond*10; i++) {
                    for(let item of inviewItems) {
                        item.style.fontKerning = 'none'
                        timeline.call(() => { shuffleElementTexts(item, moveOneLetter) }, {}, (1/shufflePerSecond)*i)
                    }
                }

            }, { threshold: [0] });

            data.current.container.querySelectorAll('*').forEach(item => {
                observer.observe(item);
            })
        })

        return Promise.all([timeoutPromise])
    },
    enter(data) {
        document.documentElement.scrollTop = 0

        const shufflePromise = new Promise(resolve => {
            let inviewItems = []

            let observer = new IntersectionObserver((entries, observer) => {
                // Add each intersecting entry to inviewItems array
                entries.forEach((entry) => {
                    if(entry.isIntersecting) {
                        const target = entry.target;
                        if((!target.children.length || target.dataset.allowShuffle != undefined) && target.innerText) {
                            inviewItems.push(target)
                            target.setAttribute('aria-label', target.innerText)
                        }
                    }
                })

                // console.log(inviewItems);

                // Destroy intersection observer
                observer.disconnect()
                observer = null;

                // Do the shuffle
                timeline && timeline.kill && timeline.kill()
                timeline = gsap.timeline({
                    onComplete: () => {

                        for(let item of inviewItems) {
                            item.innerText = item.getAttribute('aria-label')
                            item.removeAttribute('aria-label')
                            item.style.fontKerning = ''
                        }

                        resolve();
                    }
                })
                // timeline.from(data.next.container, { opacity: 0, duration: DURATION/2 }, DURATION/2);

                const shufflePerSecond = 4;
                const shuffleDelay = DURATION/shufflePerSecond

                for(let i = 0; i < shufflePerSecond; i++) {
                    for(let item of inviewItems) {
                        item.style.fontKerning = 'none'
                        timeline.call(() => { shuffleElementTexts(item, moveOneLetter) }, {}, shuffleDelay*i)
                    }
                }

            }, { threshold: [0] });

            data.next.container.querySelectorAll('*').forEach(item => {
                observer.observe(item);
            })
        })

        // return gsap.from(data.next.container, {
        //     duration: DURATION,
        //     opacity: 0,
        //     delay: .1
        // });

        return shufflePromise
    }
}
